<template>
  <v-expansion-panels flat accordion v-model="panel" multiple>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.contractual_commitment') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <display-checkbox
          class="px-2"
          :label="
            generateMessage(
              'properties_360.fields.energy_management.fictitious_enabled'
            )
          "
          :input-value="property.energy_management.fictitious_enabled"
        />
        <div class="d-flex">
          <div style="width: 50%" class="mx-2">
            <v-simple-table dense class="my-2 background no-hover">
              <tbody>
                <tr>
                  <td class="caption px-2 py-0 font-weight-bold">
                    Type de marché
                  </td>

                  <td class="caption px-2 py-0 text-end">
                    <span class="caption pa-0 font-weight-bold">
                      {{ property.market_type }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <div class="d-flex">
              <custom-simple-table
                style="width: 50%"
                class="px-2"
                :item="property.energetic_efficiency"
                i18-path="properties_360.fields.energetic_efficiency"
                :table-keys="['heating_period']"
              />
              <custom-simple-table
                style="width: 50%"
                class="px-2"
                :item="property.energy_management"
                i18-path="properties_360.fields.energy_management"
                :table-keys="['maintenance_shutdown_period']"
              />
            </div>

            <v-simple-table dense class="background my-2 no-hover">
              <tbody>
                <tr>
                  <td class="caption px-2 py-0 font-weight-bold">
                    Fréquence de relève
                  </td>

                  <td class="caption px-2 py-0 text-end">
                    <span class="caption pa-0 font-weight-bold">
                      en chauffe
                    </span>
                    <span class="caption pa-0 text-end">
                      {{ property.energetic_efficiency.frequency_with_heating }}
                    </span>
                  </td>
                  <td class="caption px-2 py-0 text-end">
                    <span class="caption pa-0 font-weight-bold">
                      hors chauffe
                    </span>
                    <span class="caption pa-0 text-end">
                      {{
                        property.energetic_efficiency.frequency_without_heating
                      }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div style="width: 50%" class="mx-2">
            <div class="caption font-weight-bold pt-2">
              {{ generateMessage('properties_360.titles.temperature') }} :
            </div>
            <div class="d-flex">
              <div class="caption font-weight-bold pt-2">
                {{ generateMessage('properties_360.fields.hot_water') }} :
              </div>
              <custom-simple-table
                class="px-2 ml-8"
                :item="property.energetic_efficiency"
                i18-path="properties_360.fields.energetic_efficiency"
                table-units="temperature"
                :table-keys="[
                  'dhw_temperature_prod',
                  'dhw_temperature_tapwater',
                ]"
              />
              <custom-simple-table
                class="px-2 ml-8"
                :item="property.energetic_efficiency"
                i18-path="properties_360.fields.energetic_efficiency"
                table-units="temperature"
                :table-keys="[
                  'dhw_temperature_prod_min',
                  'dhw_temperature_tapwater_min',
                ]"
              />
              <custom-simple-table
                class="px-2 ml-8"
                :item="property.energetic_efficiency"
                i18-path="properties_360.fields.energetic_efficiency"
                table-units="temperature"
                :table-keys="[
                  'dhw_temperature_prod_max',
                  'dhw_temperature_tapwater_max',
                ]"
              />
            </div>

            <div class="d-flex">
              <div class="caption font-weight-bold pt-2">
                {{ generateMessage('properties_360.fields.inside') }} :
              </div>
              <custom-simple-table
                class="px-2 ml-8"
                :item="property.energetic_efficiency"
                i18-path="properties_360.fields.energetic_efficiency"
                table-units="temperature"
                :table-keys="['temperature_interior', 'temperature_ac']"
              />
              <custom-simple-table
                class="px-2 ml-8"
                :item="property.energetic_efficiency"
                i18-path="properties_360.fields.energetic_efficiency"
                table-units="temperature"
                :table-keys="['temperature_interior_min', 'temperature_ac_min']"
              />
              <custom-simple-table
                class="px-2 ml-8"
                :item="property.energetic_efficiency"
                i18-path="properties_360.fields.energetic_efficiency"
                table-units="temperature"
                :table-keys="['temperature_interior_max', 'temperature_ac_max']"
              />
            </div>
            <custom-simple-table
              :item="property"
              class="pt-2"
              style="max-width: 250px;"
              i18-path="properties_360.fields.energetic_efficiency"
              :table-keys="['reduced_temperature']"
            />
          </div>
        </div>
      </v-expansion-panel-content>
    </display-expansion-panel>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.property') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <display-checkbox
          class="py-5"
          :label="
            generateMessage(
              'properties_360.fields.energy_management.command_authorized'
            )
          "
          :input-value="property.energy_management.command_authorized"
        />
        <div class="d-flex">
          <div style="width: 50%" class="px-3">
            <custom-simple-table
              :item="propertyDetails"
              i18-path="properties_360.fields"
              :table-keys="[
                'technician_affected',
                'fees_prestation_name',
                'autonomy',
                'observation',
                'altitude',
                'geographical_area',
              ]"
            />
            <span class="caption font-weight-bold">
              {{
                generateMessage(
                  'properties_360.fields.energy_management.stations.name'
                )
              }}
              :
            </span>
            <span class="caption" v-if="stations.length">
              {{ stations[0].name }} : {{ stations[0].temperature }}°C
            </span>
          </div>
          <div style="width: 50%" class="px-3">
            <custom-simple-table
              :item="propertyDetails"
              i18-path="properties_360.fields"
              :table-keys="[
                'heating_program',
                'fuel_type',
                'fluid_coolant',
                'power_hot',
                'cold_power',
                'power_unit',
              ]"
            />
          </div>
        </div>
      </v-expansion-panel-content>
    </display-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { generateMessage } from '@/utils/i18n';

import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import DisplayCheckbox from '@/components/displays/DisplayCheckbox';
import { mapGetters } from 'vuex';
import DisplayExpansionPanel from '@/components/displays/panels/DisplayExpansionPanel';
import DisplayExpansionPanelHeader from '@/components/displays/panels/DisplayExpansionPanelHeader';

export default {
  name: 'EnergyPerformanceTab',
  components: {
    DisplayExpansionPanelHeader,
    DisplayExpansionPanel,
    CustomSimpleTable,
    DisplayCheckbox,
  },
  computed: {
    ...mapGetters({
      property: 'properties_360/current',
      stations: 'properties_360/weather/items',
    }),
    propertyDetails() {
      return {
        technician_affected: this.property.energy_management
          .technician_affected,
        fees_prestation_name: this.property.energy_management
          .fees_prestation_name,
        autonomy: this.property.energy_management.autonomy,
        observation: this.property.maintenance.observation,
        altitude: this.property.energy_management.altitude,
        geographical_area: this.property.energy_management.geographical_area,
        heating_program: this.property.maintenance.heating_program,
        fuel_type: this.property.energy_management.fuel_type,
        fluid_coolant: this.property.maintenance.fluid_coolant,
        power_hot: this.property.maintenance.power_hot,
        cold_power: this.property.maintenance.cold_power,
        power_unit: this.property.maintenance.power_unit,
      };
    },
  },
  data() {
    return {
      panel: [0, 1],
    };
  },
  methods: {
    generateMessage,
  },
};
</script>
<style scoped>
.no-hover {
  pointer-events: none;
}
</style>
